module.exports = __webpack_public_path__ + "media/img/vca/prizes/beautehub-59480da704acbaf1359aa7f04f589b66.png";